import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DomainDetailComponent } from './pages/domain-detail/domain-detail.component';
import { DomainsListComponent } from './pages/domains-list/domains-list.component';
import { DomainsWizardComponent } from './pages/domains-wizard/domains-wizard.component';

const routes: Routes = [
  {
    path: '',
    component: DomainsListComponent,
    data: {
      title: 'Settings - Domains',
    },
  },
  {
    path: 'new',
    component: DomainsWizardComponent,
    data: {
      title: 'Settings - Add Domain',
    },
  },
  {
    path: ':uuid',
    component: DomainDetailComponent,
    data: {
      title: 'Settings - Domain Details',
    },
  },
  {
    path: 'wizard',
    component: DomainsWizardComponent,
  },
  {
    path: 'wizard/:siteId',
    component: DomainsWizardComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DomainsRoutingModule {}
